// extracted by mini-css-extract-plugin
module.exports = {"tileOverlay":"sG","defaultTileOverlay":"sH","defaultRentalTileOverlay":"sI","tileOverlayOn":"sJ","tileOverlayOff":"sK","addRemoveButton":"sL","circularFrame":"sM"};